/* ==========================================================================
   Fierce Health — Affiliate Template
   Drawer-friendly add-to-cart handler.

   Behavior:
   - Intercepts clicks on links with [data-aff-add-to-cart]
   - AJAX-adds the variant via /cart/add.js (no page reload)
   - Refreshes the cart-drawer and cart-icon-bubble sections (Dawn-based themes)
   - Opens the cart drawer
   - Sets the affiliate discount cookie once on page load so it's already
     applied by the time the user adds anything

   If anything fails, falls back to the link's href (the standard cart
   permalink) so users still end up on /cart with the product added.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Apply discount cookie once on page load ---------- */
  function applyDiscount() {
    var meta = document.querySelector('meta[name="aff-discount-code"]');
    if (!meta || !meta.content) return;
    // /discount/CODE sets the discount cookie and redirects. We follow it
    // silently via fetch so the user's tab stays put.
    fetch('/discount/' + encodeURIComponent(meta.content), { credentials: 'include' })
      .catch(function () { /* silent fail */ });
  }

  /* ---------- Refresh cart drawer + icon ---------- */
  function refreshCartSections() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'include' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections) return;

        if (sections['cart-drawer']) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = doc.querySelector('cart-drawer');
            if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          }
        }

        if (sections['cart-icon-bubble']) {
          var icon = document.querySelector('#cart-icon-bubble');
          if (icon) {
            var parser2 = new DOMParser();
            var doc2 = parser2.parseFromString(sections['cart-icon-bubble'], 'text/html');
            icon.innerHTML = doc2.body.innerHTML;
          }
        }
      })
      .catch(function () { /* silent fail */ });
  }

  /* ---------- Open the cart drawer (tries several theme patterns) ---------- */
  function openCartDrawer() {
    // Dawn-style custom element
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
      return;
    }

    // Common event names other themes listen for
    ['cart:open', 'cart-drawer:open', 'cart:refresh', 'cart:updated', 'drawer:open'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });

    // Last resort: click the header cart link to reveal the drawer
    var cartLink = document.querySelector('a[href="/cart"], a[href$="/cart"]');
    if (cartLink) cartLink.click();
  }

  /* ---------- Click handler ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-aff-add-to-cart]');
    if (!link) return;
    e.preventDefault();

    var variantId = link.getAttribute('data-variant-id');
    var sellingPlan = link.getAttribute('data-selling-plan');

    // If there's a frequency selector in the same card/section, prefer the chosen radio.
    // Scope to the closest [data-aff-product] card first (for multi-card trio layouts),
    // then fall back to section-wide scope (for single-product hero).
    var scope = link.closest('[data-aff-product]') || link.closest('section') || link.closest('.aff-page');
    if (scope) {
      var chosen = scope.querySelector('input[data-aff-plan-radio]:checked');
      if (chosen && chosen.value) {
        sellingPlan = chosen.value;
      }
    }

    if (!variantId) {
      window.location.href = link.href;
      return;
    }

    // Visual feedback: temporarily dim the button
    link.style.opacity = '0.6';
    link.style.pointerEvents = 'none';
    var restore = function () {
      link.style.opacity = '';
      link.style.pointerEvents = '';
    };

    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlan) {
      item.selling_plan = parseInt(sellingPlan, 10);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [item] }),
      credentials: 'include'
    })
      .then(function (resp) {
        if (!resp.ok) throw new Error('Add to cart failed: ' + resp.status);
        return resp.json();
      })
      .then(function () { return refreshCartSections(); })
      .then(function () {
        openCartDrawer();
        restore();
      })
      .catch(function (err) {
        console.error('Affiliate add to cart error:', err);
        restore();
        // Fall back to the standard cart permalink so user still gets product in cart
        window.location.href = link.href;
      });
  });

  /* ---------- Keep CTA href in sync with selected plan ---------- */
  // When a visitor changes the frequency radio, rewrite the link's href so
  // the no-JS fallback path (cart permalink) carries the correct selling_plan.
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[data-aff-plan-radio]')) return;
    var scope = e.target.closest('[data-aff-product]') || e.target.closest('section') || e.target.closest('.aff-page');
    if (!scope) return;
    var link = scope.querySelector('[data-aff-add-to-cart]');
    if (!link) return;

    link.setAttribute('data-selling-plan', e.target.value);

    // Rewrite href's selling_plan param (if present)
    try {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('selling_plan', e.target.value);
      link.href = url.toString();
    } catch (err) { /* href is malformed or relative — safe to ignore */ }
  });

  /* ---------- Init ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDiscount);
  } else {
    applyDiscount();
  }
})();